import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import TriagePage from "./pages/TriagePage";
import DiscoveryPage from "./pages/DiscoveryPage";
import ProtectedRoute from "./ProtectedRoute";
import POCPage from "./pages/POCPage";
import AoAPage from "./pages/AoAPage";
import BpmImprovementPage from "./pages/BpmImprovementPage";
import BpmImportPage from "./pages/BpmImportPage";
import RequirementsPage from "./pages/RequirementsPage";
import SecurityPage from "./pages/SecurityPage";
import TABPage from "./pages/TABPage";
import ExecutionPage from "./pages/ExecutionPage";
import ServiceNowTicketsPage from "./pages/ServiceNowTicketsPage";
import PortfolioPage from "./pages/PortfolioPage";
import DemandArtifactsPage from "./pages/DemandArtifactsPage";
import WorkflowAdminPage from "./pages/WorkflowAdminPage";
import CyberPage from "./pages/CyberPage";
import ChargebackPage from "./pages/ChargebackPage";
import { FloatingChatGate } from "./features/chatbot/FloatingChat";
import { DemandProvider } from "./context/DemandContext";
import "./App.css";
import "./styles/cares-theme.css";  // must load after App.css

// TRM v2 Components
import TRMOverview from "./components/TRM/TRMOverview";
import TraConformancePage from "./components/TRM/TraConformancePage";
import DataSourcesPage from "./components/TRM/DataSourcesPage";
import MegabytePage from "./components/TRM/MegabytePage";
import TRMAnalyticsDashboard from "./components/TRM/TRMAnalyticsDashboard";
import ProductPortfolio from "./components/TRM/ProductPortfolio";
import SoftwareLicenses from "./components/TRM/SoftwareLicenses";
import FinancialTracking from "./components/TRM/FinancialTracking";
import ConsolidationAnalysis from "./components/TRM/ConsolidationAnalysis";
import LifecycleManagement from "./components/TRM/LifecycleManagement";
import TaxonomyBrowser from "./components/TRM/TaxonomyBrowser";
import CategoryAnalysis from "./components/TRM/CategoryAnalysis";
import VersionTrends from "./components/TRM/VersionTrends";
import ProductGovernanceDashboard from "./components/TRM/Reports/ProductGovernanceDashboard";
import SpendByManufacturer from "./components/TRM/Reports/SpendByManufacturer";

function App() {
  return (
    // DemandProvider wraps everything because the stage screens are reached two
    // ways: through the routes below, and through Dashboard.js's own activeTab
    // switch. Holding the selection here is what lets both agree on which demand
    // is open — previously each page fell back to a hardcoded "DEM-001".
    <DemandProvider>
    <Router basename='/aieaai'>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/" element={<Dashboard />} /> {/* Default route */}

          {/* All seven stages are routable. Only triage and discovery were before,
              so the other five had no linkable URL at all. */}
          <Route path="/triage/:demandId" element={<TriagePage />} />
          <Route path="/triage" element={<TriagePage />} />
          <Route path="/discovery/:demandId" element={<DiscoveryPage />} />
          <Route path="/discovery" element={<DiscoveryPage />} />
          <Route path="/aoa/:demandId" element={<AoAPage />} />
          <Route path="/aoa" element={<AoAPage />} />
          <Route path="/poc/:demandId" element={<POCPage />} />
          <Route path="/poc" element={<POCPage />} />
          <Route path="/requirements/:demandId" element={<RequirementsPage />} />
          <Route path="/requirements" element={<RequirementsPage />} />
          <Route path="/security/:demandId" element={<SecurityPage />} />
          <Route path="/security" element={<SecurityPage />} />
          <Route path="/tab/:demandId" element={<TABPage />} />
          <Route path="/tab" element={<TABPage />} />
          <Route path="/execution/:demandId" element={<ExecutionPage />} />
          <Route path="/execution" element={<ExecutionPage />} />
          <Route path="/artifacts/:demandId" element={<DemandArtifactsPage />} />
          <Route path="/artifacts" element={<DemandArtifactsPage />} />
          <Route path="/bpm" element={<BpmImprovementPage />} />
          <Route path="/bpm/import" element={<BpmImportPage />} />
          <Route path="/chargeback" element={<ChargebackPage />} />
          <Route path="/cyber" element={<CyberPage />} />
          <Route path="/cyber/risk-map" element={<CyberPage initialTab="riskmap" />} />
          <Route path="/cyber/vulnerabilities" element={<CyberPage initialTab="vulnerabilities" />} />
          <Route path="/cyber/lifecycle" element={<CyberPage initialTab="lifecycle" />} />
          <Route path="/cyber/opensource" element={<CyberPage initialTab="opensource" />} />
          <Route path="/cyber/supply-chain" element={<CyberPage initialTab="supply" />} />
          <Route path="/cyber/sbom" element={<CyberPage initialTab="sbom" />} />
          <Route path="/cyber/authorisation" element={<CyberPage initialTab="authorisation" />} />
          <Route path="/cyber/ai-systems" element={<CyberPage initialTab="ai" />} />
          <Route path="/cyber/trends" element={<CyberPage initialTab="trends" />} />
          <Route path="/admin/workflows" element={<WorkflowAdminPage />} />
          <Route path="/servicenow-tickets" element={<ServiceNowTicketsPage />} />
          <Route path="/priority" element={<PortfolioPage initialTab="priority" />} />
          <Route path="/budget" element={<PortfolioPage initialTab="budget" />} />
          <Route path="/investment" element={<PortfolioPage initialTab="investments" />} />

          {/* TRM v2 Routes */}
          <Route path="/trm" element={<TRMOverview />} />
          <Route path="/trm/analytics" element={<TRMAnalyticsDashboard />} />
          <Route path="/trm/products" element={<ProductPortfolio />} />
          <Route path="/trm/licenses" element={<SoftwareLicenses />} />
          <Route path="/trm/financial" element={<FinancialTracking />} />
          <Route path="/trm/consolidation" element={<ConsolidationAnalysis />} />
          <Route path="/trm/lifecycle" element={<LifecycleManagement />} />
          <Route path="/trm/taxonomy" element={<TaxonomyBrowser />} />
          <Route path="/trm/tra" element={<TraConformancePage />} />
          <Route path="/trm/sources" element={<DataSourcesPage />} />
          <Route path="/trm/megabyte" element={<MegabytePage />} />
          <Route path="/trm/categories" element={<CategoryAnalysis />} />
          <Route path="/trm/versions" element={<VersionTrends />} />
          <Route path="/trm/reports/governance" element={<ProductGovernanceDashboard />} />
          <Route path="/trm/reports/spend" element={<SpendByManufacturer />} />
        </Route>
      </Routes>
      {/* Sibling of <Routes>, inside <Router>, so it persists across navigation
          and can still read the current path to hide itself on /login. */}
      <FloatingChatGate />
    </Router>
    </DemandProvider>
  );
}

export default App;
